{
  "title": "Investiture of Flame",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "6th-level transmutation",
  "level": 6,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Flames race across your body, shedding bright light in a 30-foot radius and dim light for an additional 30 feet for the spell’s duration. The flames don’t harm you. Until the spell ends, you gain the following benefits:",
    "You are immune to fire damage and have resistance to cold damage.",
    "Any creature that moves within 5 feet of you for the first time on a turn or ends its turn there takes 1d10 fire damage.",
    "You can use your action to create a line of fire 15 feet long and 5 feet wide extending from you in a direction you choose. Each creature in the line must make a Dexterity saving throw. A creature takes 4d8 fire damage on a failed save, or half as much damage on a successful one."
  ],
  "spellLists": ["druid", "sorcerer", "warlock", "wizard"]
}
